import { useApiToast } from 'components/Toaster';
import { getDatalists } from 'features/datalist/datalist.slice';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useUpdateAppointmentMutation } from 'services/appointment/appointment.endpoint';
import { Appointment } from 'services/appointment/appointment.types';

export default function useAppointmentsVM() {
    const { datalists } = useSelector(getDatalists);
    const [appointments, setAppointments] = useState<Appointment[]>([]);
    const [isAppointmentInfoModalOpen, setIsAppointmentInfoModalOpen] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState<Appointment>();
    const { showErrorToast } = useApiToast();

    console.log('selectedAppointment', selectedAppointment);

    const [
        updateAppointment,
        {
            isLoading: isUpdatingAppointment,
            isError: isUpdatingAppointmentError,
            error: updatingAppointmentError,
            isSuccess: isUpdatingAppointmentSuccess,
            data: updatingAppointmentData
        }
    ] = useUpdateAppointmentMutation();

    useEffect(() => {
        if (selectedAppointment) {
            setIsAppointmentInfoModalOpen(true);
        }
    }, [selectedAppointment]);

    const handleUpdateAppointment = (status: 'accepted' | 'refused') => {
        if (!selectedAppointment) return;
        updateAppointment({
            id: selectedAppointment.id,
            status,
            project_id: selectedAppointment.project_id
        });
    };

    useEffect(() => {
        if (isUpdatingAppointment) return;
        if (isUpdatingAppointmentError && updatingAppointmentError) {
            showErrorToast(updatingAppointmentError, {
                message: 'Erreur de mise à jour du rendez-vous'
            });
            return;
        }
        if (isUpdatingAppointmentSuccess && updatingAppointmentData) {
            const updatedAppointment = updatingAppointmentData.data;
            setAppointments(
                appointments.map((appointment) => (appointment.id === updatedAppointment.id ? updatedAppointment : appointment))
            );
            return;
        }
    }, [
        isUpdatingAppointment,
        isUpdatingAppointmentError,
        updatingAppointmentError,
        isUpdatingAppointmentSuccess,
        updatingAppointmentData
    ]);

    return {
        datalists,
        appointments,
        setAppointments,
        isAppointmentInfoModalOpen,
        setIsAppointmentInfoModalOpen,
        selectedAppointment,
        setSelectedAppointment,
        handleUpdateAppointment
    };
}
